export default "/images/efectivo.png?b236b60e743bc85d920855698bba5957";